import { ArrowRight2 } from 'iconsax-reactjs';
import type { FC } from 'react';
import { cn } from '@/shared/react';
import { BreadcrumbJsonLd } from './BreadcrumbJsonLd';

// Emits the BreadcrumbList structured data plus a matching on-page trail.
// Defaults to `sr-only` so the breadcrumb is present in the DOM for crawlers
// (and screen readers) without being shown to sighted users.
export const Breadcrumb: FC<{
  items: { name: string; url: string }[];
  className?: string;
}> = ({ items, className }) => (
  <>
    <BreadcrumbJsonLd items={items} />
    <nav aria-label="Breadcrumb" className={cn('p-widget text-xs', className)}>
      <ol className="flex items-center gap-2 text-nowrap overflow-auto pe-6 max-w-full">
        {items.map((item, index) => (
          <li key={item.url} className="flex items-center gap-2">
            {index > 0 && <ArrowRight2 className="auto-rtl" size={10} />}
            {index < items.length - 1 ? (
              <a href={item.url} className="hover:underline">
                {item.name}
              </a>
            ) : (
              <span aria-current="page">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  </>
);
